var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCocosKeelingIslands(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "green",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe000",
    d: "m24.84 13.49.14.5h.49l-.39.3.14.48-.38-.3-.39.28.14-.46-.38-.3h.47zm-1.28-5.5-.56.53.05-.78-.76-.12.64-.44-.39-.68.74.23.28-.73.28.73.74-.23-.38.68.63.44-.76.12.06.78zm-3.02 4.49-.56.53.05-.78-.76-.12.64-.44-.39-.68.74.23.28-.72.29.72.73-.23-.38.68.63.44-.76.12.06.78zm5.93-.37-.57.53.06-.78-.76-.12.63-.44-.38-.68.73.23.29-.73.28.73.74-.23-.39.68.64.44-.76.12.05.78zm-2.96 6.55-.56.53.05-.78-.76-.12.64-.44-.39-.68.74.23.28-.73.28.73.74-.23-.38.68.63.44-.76.12.06.78zm-7.14-3.24a3.3 3.3 0 0 1-3.29-3.34 3.3 3.3 0 0 1 3.29-3.33q1 0 1.85.59a4 4 0 0 0-3.1-1.44A4.15 4.15 0 0 0 11 12.08a4.15 4.15 0 0 0 4.12 4.19c1.24 0 2.35-.56 3.1-1.44-.54.38-1.19.59-1.85.59M10 5.89a4 4 0 1 1-8 .34 4 4 0 0 1 8-.34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#802000",
    d: "M6.2 9.03h-.89s.3-.27.45-.52.76-1.58.7-2.8c-.08-1.21.13-1.01.2-.29.07.73 0 2.21-.12 2.65-.13.43-.27.7-.09.76s.24.2.24.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "green",
    d: "M4.66 3.47h.54l1.1 1.06-.37-.69.34-.21.1-.85.94-.08-.13.47.49.26-.54.79 1.18-.11-.22.7h.64l.26.87-1.56-.12.78.58v.9L6.58 5.48l-.14.65-.1.66-.36.1-.09-.5-.37.63h-.5l.48-1.76-2.5.47.67-.81 1.32-.27-1.17-.6 1.73.3-1.79-.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCocosKeelingIslands);
export default __webpack_public_path__ + "static/media/cocos-keeling-islands.cdd16b0f10badac72e5394988366e93b.svg";
export { ForwardRef as ReactComponent };